import { useState, useEffect } from 'react';

import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface CustomThumbnailUploadProps {
  value?: string;
  onChange: (url?: string) => void;
  projectId: string;
  disabled?: boolean;
}

export function CustomThumbnailUpload({
  value,
  onChange,
  disabled,
}: CustomThumbnailUploadProps) {
  const [urlInput, setUrlInput] = useState(value || '');

  // Sync when parent loads existing app data async after mount
  useEffect(() => {
    setUrlInput(value || '');
  }, [value]);

  const handleUrlBlur = () => {
    const trimmed = urlInput.trim();
    onChange(trimmed || undefined);
  };

  return (
    <div className="space-y-2">
      <Label>Custom Thumbnail URL (Optional)</Label>
      <p className="text-xs text-muted-foreground">
        Shown on app library cards. If not set, the deployment screenshot is used.
      </p>

      <Input
        type="url"
        placeholder="https://example.com/thumbnail.jpg"
        value={urlInput}
        onChange={(e) => setUrlInput(e.target.value)}
        onBlur={handleUrlBlur}
        disabled={disabled}
      />

      {urlInput && (
        <div className="rounded-lg overflow-hidden border border-border aspect-video">
          <img
            src={urlInput}
            alt="URL thumbnail preview"
            className="w-full h-full object-cover"
            onError={(e) => {
              e.currentTarget.style.display = 'none';
            }}
          />
        </div>
      )}
    </div>
  );
}
